// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2kj7w";
var _4 = "wrapper-1vUnG";
var _5 = "arrow-1LYIh";
var _6 = "title-2MOiP";
var _7 = "close-2uiOJ";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "wrapper", _5 as "arrow", _6 as "title", _7 as "close" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "wrapper": _4, "arrow": _5, "title": _6, "close": _7 }
